import React from "react"
import { graphql } from "gatsby"
import Page from "../components/Page"
import Contribute from "../screens/Contribute"
import SEO from "../components/SEO"

const ContributePage: React.FC<{}> = function (props) {
  return (
    <Page contactUsVisibility="hide">
      <SEO title="Contribute" />
      <Contribute
        data={props.data.allContentfulContributeGuidelines.edges[0].node}
      ></Contribute>
    </Page>
  )
}

export default ContributePage
export const query = graphql`
  {
    allContentfulContributeGuidelines {
      edges {
        node {
          id
          contributeDescription {
            contributeDescription
          }
          englishGuidelines {
            englishGuidelines
          }
          englishArticle {
            slug
          }
          artworkGuidelines {
            artworkGuidelines
          }
          artworkArticle {
            slug
          }
          filipinoArticle {
            slug
          }
          filipinoGuidelines {
            filipinoGuidelines
          }
        }
      }
    }
  }
`
